/* eslint-disable no-unused-vars */
// noinspection JSUnusedGlobalSymbols
export enum ProjectSupportType {
  Financial = 'Financial',
  InKind = 'InKind',
}
